export var EmitterType;
(function (EmitterType) {
    EmitterType["local"] = "local";
    EmitterType["remote"] = "remote";
})(EmitterType || (EmitterType = {}));
//# sourceMappingURL=emitterType.enum.js.map